var STORAGE_LOCATIONS: {
  PRODUCT_IMAGES: string,
  BANK_TRANSACTIONS: string,
  TERMS_AND_CONDITIONS: string,
  COMMISSION_UPLOADS: string,
  PAYPAL_PAYMENTS: string,
  PAYNAMICS_PAYMENTS: string,
  IPAY88_PAYMENTS: string
} = {
  PRODUCT_IMAGES: 'merchant-portal-product-images-dev',
  BANK_TRANSACTIONS: 'merchant-portal-bank-transactions-dev',
  TERMS_AND_CONDITIONS: 'merchant-portal-terms-and-conditions-dev',
  COMMISSION_UPLOADS: 'merchant-portal-commission-uploads-dev',
  PAYPAL_PAYMENTS: 'merchant-portal-bank-transactions-dev',
  PAYNAMICS_PAYMENTS: 'merchant-portal-bank-transactions-dev',
  IPAY88_PAYMENTS: 'merchant-portal-bank-transactions-dev'
};

export { STORAGE_LOCATIONS };

